import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/ecrin-eye")({
  component: () => <Navigate to="/caileve-eye" replace search={{ token: undefined, mode: undefined }} />,
});
